import { Compass, TrendingUp, GraduationCap, Cog, Network, Gauge, Megaphone, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia } from "./SectionMedia";
import { useApp, scrollToSection } from "../store";

const ICONS = [Compass, TrendingUp, GraduationCap, Cog, Network, Gauge, Megaphone];
const SPANS = [
  "lg:col-span-2 lg:row-span-2",
  "lg:col-span-2",
  "",
  "",
  "lg:col-span-2",
  "",
  "",
];

export const Services = () => {
  const { c, t } = useApp();

  return (
    <section id="expertises" data-testid="services-section" className="relative text-white grain" style={{ background: "var(--sec-expertises-bg, #101E3D)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <Eyebrow>{t("services_eyebrow")}</Eyebrow>
            <h2 data-testid="services-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
              {t("services_title")}
            </h2>
          </div>
          <p className="max-w-sm text-sm sm:text-base text-white/60 leading-relaxed">{t("services_sub")}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {ICONS.map((Icon, i) => (
            <Reveal key={i} delay={i * 0.06} className={SPANS[i]}>
              <article
                data-testid={`service-card-${i + 1}`}
                className="group relative h-full min-h-[180px] bg-white/[0.06] border border-[var(--accent-soft)]/10 p-7 flex flex-col justify-between overflow-hidden transition-all duration-500 hover:border-[var(--accent)]/60 hover:-translate-y-1"
              >
                <div className="absolute -right-8 -bottom-8 w-32 h-32 rounded-full bg-[var(--accent)]/0 blur-2xl transition-all duration-700 group-hover:bg-[var(--accent)]/10" />
                <div className="flex items-start justify-between">
                  <span className="w-11 h-11 grid place-items-center border border-[var(--accent)]/40 text-[var(--accent-soft)] transition-colors duration-500 group-hover:bg-[var(--accent)] group-hover:text-white">
                    <Icon size={20} strokeWidth={1.6} />
                  </span>
                  <span className="font-mono2 text-xs text-white/30">0{i + 1}</span>
                </div>
                <div className="mt-8">
                  <h3 className={`font-display font-semibold ${i === 0 ? "text-2xl sm:text-3xl" : "text-xl"}`}>
                    {c(`service_${i + 1}_title`)}
                  </h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed max-w-md">
                    {c(`service_${i + 1}_desc`)}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.45} className="lg:col-span-4">
            <button
              data-testid="services-cta-card"
              onClick={() => scrollToSection("#contact")}
              className="group w-full min-h-[120px] bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white p-7 flex flex-row items-center justify-between gap-6 text-left transition-colors duration-500"
            >
              <span className="font-display font-semibold text-xl sm:text-2xl leading-snug">{t("cta_start")}</span>
              <ArrowUpRight size={30} className="shrink-0 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </Reveal>
        </div>

        <SectionMedia section="expertises" />
      </div>
    </section>
  );
};
